export enum ReportStatus {
  IMPORTED = 'IMPORTED',
  RETRIEVED = 'RETRIEVED',
  PROCESSED = 'PROCESSED',
  PAID = 'PAID',
  IN_PROGRESS = 'IN PROGRESS',
  NOT_YET_SUBMITTED = 'NOT YET SUBMITTED',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}
